import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.book.editrawunit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_RAWUNIT_ASYNC: `${uid}.saveRawUnitAsync`,
    SAVE_RAWUNIT_SUCCESS: `${uid}.saveRawUnitSuccess`,
    SAVE_RAWUNIT_FAILURE: `${uid}.saveRawUnitFailure`,
    UPLOAD_IMAGE_ASYNC: `${uid}.uploadImageAsync`,
    UPLOAD_IMAGE_SUCCESS: `${uid}.uploadImageSuccess`,
    UPLOAD_IMAGE_FAILURE: `${uid}.uploadImageFailure`, 
    REMOVE_IMAGE: `${uid}.removeImage`, 
    CHANGE_IMAGE: `${uid}.changeImage`, 
};

export { ActionTypes };
